import { Type } from 'class-transformer'
import { Entity } from '..'

import { Payment, PaymentOrder, PaymentOrderItem } from '.'
import { Person } from '../persons'
import { parseToNumber } from '@/utils/general'

export class PaymentRecipient extends Entity {
  @Type(() => Payment)
  payments: Payment[]

  @Type(() => PaymentOrder)
  paymentOrder: PaymentOrder

  @Type(() => PaymentOrderItem)
  paymentOrderItem: PaymentOrderItem

  @Type(() => Person)
  person: Person

  purchaseOrder: Record<string, any>
  expense: number | string

  get expenseDetails () {
    const { paymentOrderItem, purchaseOrder, expense } = this

    let totalExpense = 0

    purchaseOrder?.expenses?.payments?.forEach(payment => {
      totalExpense += parseToNumber(payment.amount)
    })
    const amount = paymentOrderItem?.amount

    const availableAmount = parseToNumber(amount) - (parseToNumber(totalExpense) + parseToNumber(expense))
    return {
      total: amount,
      expenses: totalExpense + (parseToNumber(expense || 0)),
      available: availableAmount,
    }
  }
}
